import { render, staticRenderFns } from "./magycorpTechnologiesSDl.vue?vue&type=template&id=64c5d96a&scoped=true&"
import script from "./magycorpTechnologiesSDl.vue?vue&type=script&lang=js&"
export * from "./magycorpTechnologiesSDl.vue?vue&type=script&lang=js&"
import style0 from "./magycorpTechnologiesSDl.vue?vue&type=style&index=0&id=64c5d96a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c5d96a",
  null
  
)

export default component.exports